import React from 'react'
import TableAdmin from '../../Components/table/TableAdmin'

const Admin = () => {
  return <TableAdmin />
}

export default Admin
